import { sum } from 'lodash';
import { removeDuplicatedSpaces } from '../../../lib';
import { SanityBlogPost, SanityBlogPostPreview } from './types';

// Ref: https://medium.com/blogging-guide/how-is-medium-article-read-time-calculated-924420338a85
// Reading time is based on the average adult reading speed (about 265 words per
// minute). Medium converts the number of words in a post to minutes, with some
// adjustments for images. The first image has 12 seconds added to the reading
// time, the second adds 11 seconds and all subsequent images add one second
// less, until the tenth image. After the tenth image, all additional ones are
// counted as three seconds each.
const WORDS_PER_MINUTE = 265;

function textReadingTime(str: string): number {
    return removeDuplicatedSpaces(str).split(' ').length / WORDS_PER_MINUTE;
}

function imageReadingTime(position: number): number {
    return (position > 9 ? 3 : 12 - position) / 60;
}

export function readingTime(
    post: SanityBlogPost | SanityBlogPostPreview
): number {
    const textContent = post.Content.filter(c => c._type === 'block')
        .map(b => b.children.map(c => c.text).join(' '))
        .join(' ');
    const imageContent = post.Content.filter(c => c._type === 'img').map(
        (_, i) => i
    );
    return (
        textReadingTime(post.title) +
        textReadingTime(post.synopsis) +
        textReadingTime((post.takeaways || []).join(' ')) +
        textReadingTime(textContent) +
        sum(imageContent.map(imageReadingTime))
    );
}
